import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-jobsearch-search_section __clm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-jobsearch-search_section_inner" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "p-jobsearch-search_hl" }, "年収")
], -1)
const _hoisted_3 = { class: "p-jobsearch-search_section_inner" }
const _hoisted_4 = ["value"]

import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { JobSearchPublicDropdownData } from '@/types/mstMyPage';
import { onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';

// 親コンポーネントからのプロパティ定義

export default /*#__PURE__*/_defineComponent({
  __name: 'AnnualIncome',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: {
    id: number;
    text: string;
  }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: {
    id: number;
    text: string;
  }
}


 const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const defaultValue = {
  id: 0,
  text: MYPAGE_CONSTANTS.STRING.JOB_SEARCH_NOT_SPECIFIED_VALUE
};

// 親コンポーネントへのイベント定義


const listIncome = ref<JobSearchPublicDropdownData[]>([]);
const selectedIncome = ref<{
    id: number;
    text: string;
}>({...defaultValue});

// 選択値が変更されたときに親コンポーネントに通知
function emitSelectedIncome() {
  const selectedOption = listIncome.value.find(inc => Number(inc.id) === selectedIncome.value.id);
  selectedIncome.value.text = selectedOption ? selectedOption.text : '';

  emit('update:modelValue', selectedIncome.value);
}

// propsからの初期値をwatchで監視
watch(() => props.modelValue, (newValue) => {
  if (newValue === null || newValue === undefined) {
    selectedIncome.value = {...defaultValue};
  } else {
    const option = listIncome.value.find(inc => Number(inc.id) === newValue.id);
    selectedIncome.value = {
      id: newValue.id,
      text: option ? option.text : ''
    };
  }
}, { immediate: true, deep: true });

const store = useStore();

onMounted(async () => {
  const defaultOpt: JobSearchPublicDropdownData = {
    id: 0,
    text: '指定しない',
    value: '0'
  };
  const income = await store.dispatch(storeBase.MST_ANUAL_SLRY);
  listIncome.value = [defaultOpt, ...income];

  // 初期値が設定されていない場合はデフォルト値を使用
  if (!selectedIncome.value && listIncome.value.length > 0) {
    if (props.modelValue){
      selectedIncome.value =  props.modelValue;
    } else {
      selectedIncome.value = {...defaultValue};
    }
    // 初期値を親に通知
    emitSelectedIncome();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        class: "p-jobsearch-search_select",
        size: "1",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedIncome.value.id) = $event)),
        onChange: emitSelectedIncome
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listIncome.value, (inc) => {
          return (_openBlock(), _createElementBlock("option", {
            key: inc.id,
            value: inc.id
          }, _toDisplayString(inc.text), 9, _hoisted_4))
        }), 128))
      ], 544), [
        [_vModelSelect, selectedIncome.value.id]
      ])
    ])
  ]))
}
}

})